/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Group_UsedInputs */

const en_cook_group_used = /** @type {(inputs: Cook_Group_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already used`)
};

const de_cook_group_used = /** @type {(inputs: Cook_Group_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schon verwendet`)
};

/**
* | output |
* | --- |
* | "Already used" |
*
* @param {Cook_Group_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_group_used = /** @type {((inputs?: Cook_Group_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Group_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_group_used(inputs)
	return en_cook_group_used(inputs)
});